import APIClient from '@/shared/http/clients/api'

const resourceName = 'motivoviagem'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const GetAllByDesligado = (venda, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByDesligado/${venda}`, data, config)
const motivoViagemVenda = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetMotivoViagemVenda/${id}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)

const TravelReasonRepository = {
  GetAll,
  GetAllByDesligado,
  motivoViagemVenda,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete
}

export default TravelReasonRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/travelreason.js